import { render, staticRenderFns } from "./ModulosPainelView.vue?vue&type=template&id=65ae3281&scoped=true&"
import script from "./ModulosPainelView.vue?vue&type=script&lang=js&"
export * from "./ModulosPainelView.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=65ae3281&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae3281",
  null
  
)

export default component.exports